// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-operations[data-v-318ce35c]{margin-top:10px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}.table-operations>div[data-v-318ce35c]{margin-right:10px}", ""]);
// Exports
module.exports = exports;
